<template>
  <a
    :class="[$style.base, ...getButtonStyle()]"
    :href="disabled ? '' : href"
    :rel="rel"
    :target="target"
    @click="handleClick"
  >
    <span :class="$style.content">
      <slot />
      <span
        v-if="!$slots.default"
      >
        <i
          v-if="icon"
          :class="[icon, $style.icon]"
        />
        <component
          :is="iconComponent"
          v-if="iconComponent"
          :class="$style.icon"
        />
        <span :class="$style.text">{{ text }}</span>
      </span>
    </span>
  </a>
</template>
<script>
/**
 * The FlatActionAnchor renders an anchor with the same styles as the
 * FlatActionButton. It is meant to avoid using the FlatActionButton and passing
 * it a method that calls window.open() when using an anchor would be more
 * appropriate.
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Semantics#Semantics_in_HTML
 * @todo Contemplate why an anchor should look like a button.
 */
export default {
  name: 'FlatActionAnchor',

  props: {
    buttonStyles: {
      type: Array,
      default: () => ['btnDefault'],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: true,
    },
    icon: {
      default: '',
      type: String,
    },
    iconComponent: {
      default: null,
      type: Object,
    },
    rel: {
      type: String,
      default: 'noopener noreferrer',
    },
    target: {
      type: String,
      default: '_blank',
    },
    text: {
      default: '',
      type: String,
    },
  },

  methods: {
    getButtonStyle() {
      return this.disabled ? ['btnDefault', this.$style.baseDisabled] : this.buttonStyles;
    },

    handleClick($e) {
      if (this.disabled) {
        $e.preventDefault();
        $e.stopImmediatePropagation();
      } else {
        this.$emit('click');
      }
    },
  },
};
</script>
<style module scoped>
@import './FlatActionStyles.css';
</style>
